export enum InvoiceType {
  VALUE_INVOICE = 'VALUE_INVOICE',
  ADAPTATION_INVOICE = 'ADAPTATION_INVOICE'
}
